import { mapState } from 'vuex';
export default {
  name: 'SizeSelect',
  props: {
    value: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data() {
    return {
      WIDGET_SIZE_OPTIONS: [{
        text: 'S',
        value: 1
      }, {
        text: 'M',
        value: 2
      }, {
        text: 'L',
        value: 3
      }, {
        text: 'XL',
        value: 4
      }],
      buttonState: 1
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  }
};